module.exports = __webpack_public_path__ + "static/media/USDT_BUSD_Cake.28b5eeef.png";